const PageContent = ({ children, className = "" }) => (
  <main
    className={`tw-relative tw-min-h-[60vh] tw-flex-1 tw-bg-dis-page tw-px-4 tw-pt-4 tw-pb-8 tw-text-dis-text-2 md:tw-py-12 ${className}`}
  >
    {children}
  </main>
);

export default PageContent;
